// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".skeleton-wrapper[data-v-1a7484c2]{-webkit-box-shadow:var(--shadow);box-shadow:var(--shadow);border-radius:var(--radius);border:var(--border);padding:var(--padding);margin:var(--margin);width:var(--width);height:var(--height)}.skeleton-wrapper *[data-v-1a7484c2]{color:var(--text-color)}.skeleton-wrapper .skeleton[data-v-1a7484c2]{background-color:var(--color);border-radius:var(--radius);width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
